export default __webpack_public_path__ + "static/media/About_A.0c0c2b37.png";